export default {
  bankTransfer: 'Przelew bankowy',
  firstTitle: 'Wybierz walutę przelewu',
  secondTitle: 'Po przelewie',
  bankTips: 'Uzyskaj informacje o odbiorcy i przejdź do odpowiedniej placówki bankowej, aby wypełnić przelew. Prosimy o dokładne sprawdzenie pisowni.',
  receiverTitle: 'Informacje o odbiorcy',
  bankAttrEnum: {
    0: 'Numer konta',
    1: 'Numer routingu',
    2: 'Nazwa konta',
    3: 'Nazwa banku',
    4: 'Adres banku',
    5: 'Kod pocztowy',
    6: 'Kraj/Region',
    7: 'Typ konta',
    8: 'Uwagi'
  },
  transferTips:
    'Możesz nas poinformować w jeden z poniższych sposobów, a sprawdzimy to jak najszybciej!',
  transferName: 'Nazwa przelewającego',
  transferBank: 'Bank przelewającego',
  transferNo: 'Numer referencyjny',
  submit: 'Prześlij teraz',
  successSubmit: 'Wniosek złożony!',
  successSubmitTips:
    '* Jeśli wystąpią jakiekolwiek problemy podczas weryfikacji, skontaktujemy się z Twoim adresem e-mail użytym do rejestracji w acbuy.',
  tradeDetail: 'Szczegóły transakcji',
  backOrder: 'Wróć do zamówienia',
  holder: {
    inputNo: 'Proszę podać numer referencyjny, jeśli jest dostępny.'
  },
  transferExplain: 'Instrukcje dotyczące przelewu bankowego:',
  transferExplainEnum: {
    0: 'acbuy nie pobiera opłat za przelew za pośrednictwem tego kanału płatniczego. To czy bank przelewający pobiera opłaty zależy od polityki danego banku.',
    1: 'Ten sposób płatności obsługuje wiele walut. Klienci mogą wybrać odpowiednie konto bankowe do przelewu zgodnie z regionem i potrzebnymi potrzebnymi.',
    2: 'Zwykle przybywa w ciągu 1-3 dni roboczych; w specjalnych okolicznościach przybywa w ciągu 1-5 dni roboczych.',
    3: 'acbuy przeliczy kwotę na RMB według kursu acbuy i zakredytuje ją na Twoje konto.',
    4: 'Kwota RMB w koncie acbuy = Kwota przelewu * kurs acbuy.'
  }
};
